<script setup>

import { defineProps, defineEmits} from "vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "pedidoDeCompra",
    "email"
]);

const emits = defineEmits([
    "update:email"
]);

//==================================================================//
//======================= Altera Com Copia =========================//
//==================================================================//

const alteraComCopia = (comCopia) =>{

    emits('update:email',{
        comCopia: comCopia
    });

}

//==================================================================//
//=================== Altera Com Copia Oculta ======================//
//==================================================================//

const alteraComCopiaOculta = (comCopiaOculta) =>{

    emits('update:email',{
        comCopiaOculta: comCopiaOculta
    });

}

//==================================================================//
//=================== Altera Com Copia Oculta ======================//
//==================================================================//

const alteraAssunto = (assunto) =>{

    emits('update:email',{
        assunto: assunto
    });

}

</script>

<template>

  <v-card
        class="c-cabecalho-email"
    >

        <v-card-title
            class="c-cabecalho-email__titulo"
        >
        
            <h3>Cabeçalho</h3>

        </v-card-title>

        <div
            class="c-cabecalho-email__conteudo"
        >

            <v-combobox
                :value="props?.email?.destinatarioEmail"
                class="c-campo"
                label="Destinatário"
                outlined
                prepend-icon="mdi-mailbox"
                chips
                dense
                readonly
            ></v-combobox>

            <v-combobox
                :value="props?.email?.comCopia"
                class="c-campo"
                label="CC"
                outlined
                prepend-icon="mdi-chevron-right"
                multiple
                chips
                dense
                @input="alteraComCopia"
            ></v-combobox>

            <v-combobox
                :value="props?.email?.comCopiaOculta"
                class="c-campo"
                label="CCo"
                outlined
                prepend-icon="mdi-chevron-double-right"
                multiple
                chips
                dense
                @input="alteraComCopiaOculta"
            ></v-combobox>

            <v-text-field
                :value="props?.email?.assunto"
                class="c-campo"
                label="Assunto"
                outlined
                prepend-icon="mdi-chat-outline"
                @input="alteraAssunto"
            ></v-text-field>

        </div>

    </v-card>

</template>

<style scoped>

.c-campo >>> .v-chip.v-size--default{
    height: 24px;
}

</style>